import React, { useState, useRef } from 'react';
import { 
  User, Mail, Phone, ShieldCheck, 
  QrCode, Camera, Edit3, Save, 
  Crown, Smartphone, X, Eye
} from 'lucide-react';

// ✅ CONEXIÓN AL CONTEXTO DE IDENTIDAD (Ruta Absoluta)
import { useAuth } from 'context/AuthContext';

const PerfilAdmin = () => {
  const { user } = useAuth(); // Extraemos los datos reales del Admin logueado
  
  const [editando, setEditando] = useState(false);
  const [fotoPreview, setFotoPreview] = useState(null);
  const fileInputRef = useRef(null);

  // DATOS REALES SINCRONIZADOS DESDE EL CORE
  const [adminData, setAdminData] = useState({
    nombre: user?.displayName || "ADMINISTRADOR GENERAL",
    nacimiento: "1985-10-20",
    telefono: user?.phone || "9933123456",
    whatsapp: true,
    correo: user?.email || "admin@casadefe.org",
    rol: "Director de Operaciones Kids",
    idSeguridad: user?.uid?.slice(-8).toUpperCase() || "ADM-GOLD-77"
  });

  const handleFotoChange = (e) => {
    const file = e.target.files[0];
    if (file) {
      const reader = new FileReader();
      reader.onloadend = () => setFotoPreview(reader.result);
      reader.readAsDataURL(file);
    }
  };

  const guardarCambios = () => {
    // Sincronización con Firebase v3.1
    setEditando(false);
    alert("✅ Perfil Maestro Actualizado.\nLos privilegios de Acceso Total han sido revalidados.");
  };

  return (
    <div className="max-w-2xl mx-auto space-y-8 animate-in fade-in duration-700 pb-20 font-sans text-left">
      
      {/* HEADER DE RANGO ADMINISTRATIVO */}
      <div className="text-center space-y-3">
        <div className="inline-flex items-center gap-2 bg-amber-50 text-amber-600 px-6 py-2 rounded-full border-2 border-amber-100 shadow-sm">
          <Crown size={18} className="fill-amber-400" />
          <span className="text-[10px] font-black uppercase tracking-[0.3em] italic">Nivel de Acceso: Total</span>
        </div>
        <h2 className="text-4xl font-black text-slate-900 italic tracking-tighter uppercase leading-none">Mi Perfil</h2>
      </div>

      {!editando ? (
        <div className="space-y-6">
          {/* GAFETE DORADO (LLAVE MAESTRA) */}
          <div className="bg-white rounded-[4rem] shadow-2xl overflow-hidden border-4 border-slate-50 transition-all hover:shadow-indigo-100/50">
            
            <div className="bg-[#0A2440] p-12 flex flex-col items-center relative overflow-hidden">
              {/* Efecto de Blindaje Dorado */}
              <div className="absolute top-0 left-0 w-full h-full bg-gradient-to-tr from-amber-500/10 to-transparent opacity-60" />
              <div className="absolute -bottom-10 -right-10 w-48 h-48 bg-indigo-500/5 rounded-full blur-3xl" />
              
              <div className="relative z-10 w-44 h-44 bg-white rounded-[3.5rem] p-1.5 shadow-2xl">
                <div className="w-full h-full bg-slate-50 rounded-[3.2rem] flex items-center justify-center text-slate-200 overflow-hidden border-2 border-slate-100">
                  {fotoPreview ? (
                    <img src={fotoPreview} alt="Admin" className="w-full h-full object-cover" />
                  ) : (
                    <User size={80} strokeWidth={1} className="text-slate-300" />
                  )}
                </div>
              </div>

              <div className="relative z-10 text-center space-y-2 mt-6">
                <h3 className="text-3xl font-black text-white italic tracking-tighter uppercase leading-none">{adminData.nombre}</h3>
                <p className="text-[10px] font-black text-amber-400 uppercase tracking-[0.4em] italic opacity-80">{adminData.rol}</p>
              </div>
            </div>

            <div className="p-12 space-y-10">
              {/* QR DE SEGURIDAD INTERNA */}
              <div className="flex flex-col items-center p-10 bg-amber-50/30 rounded-[3.5rem] border-4 border-dashed border-amber-100 relative group transition-all hover:bg-amber-50/50">
                <QrCode size={160} className="text-slate-900 mb-4 transition-transform group-hover:scale-105" strokeWidth={1} />
                <div className="text-center">
                  <p className="text-[10px] font-black text-amber-600 uppercase tracking-[0.2em] mb-1 italic">Token Administrativo Único</p>
                  <p className="text-sm font-black font-mono text-slate-400 tracking-widest">{adminData.idSeguridad}</p>
                </div>
              </div>

              <div className="grid grid-cols-1 md:grid-cols-2 gap-8 px-4">
                <div className="flex items-center gap-5">
                  <div className="w-14 h-14 rounded-2xl bg-slate-50 flex items-center justify-center text-indigo-600 shadow-inner">
                    <Smartphone size={24} />
                  </div>
                  <div className="text-left">
                    <p className="text-[9px] font-black text-slate-400 uppercase tracking-widest leading-none mb-2 italic">Línea Directa</p>
                    <div className="flex items-center gap-2">
                      <p className="text-base font-black text-slate-800">{adminData.telefono}</p>
                      {adminData.whatsapp && <div className="w-2 h-2 bg-emerald-500 rounded-full animate-pulse shadow-[0_0_8px_#10b981]" />}
                    </div>
                  </div>
                </div>

                <div className="flex items-center gap-5">
                  <div className="w-14 h-14 rounded-2xl bg-slate-50 flex items-center justify-center text-indigo-600 shadow-inner">
                    <Mail size={24} />
                  </div>
                  <div className="text-left">
                    <p className="text-[9px] font-black text-slate-400 uppercase tracking-widest leading-none mb-2 italic">Correo Oficial</p>
                    <p className="text-base font-black text-slate-800 lowercase truncate max-w-[150px]">{adminData.correo}</p>
                  </div>
                </div>
              </div>

              <button 
                onClick={() => setEditando(true)}
                className="w-full py-6 bg-slate-900 text-white rounded-[2.5rem] font-black text-xs uppercase tracking-[0.3em] shadow-xl hover:bg-indigo-600 active:scale-95 transition-all flex items-center justify-center gap-3 border-b-8 border-slate-800"
              >
                <Edit3 size={20} className="text-amber-400" /> Modificar Perfil Maestro
              </button>
            </div>
          </div>
        </div>
      ) : (
        /* FORMULARIO DE EDICIÓN ADMIN */
        <div className="bg-white p-10 rounded-[4rem] shadow-2xl border-4 border-slate-100 space-y-10 animate-in zoom-in-95 duration-300 text-left">
          <div className="flex flex-col items-center">
            <div 
              onClick={() => fileInputRef.current.click()}
              className="w-32 h-32 rounded-[2.8rem] bg-slate-50 border-4 border-dashed border-indigo-200 flex flex-col items-center justify-center text-indigo-400 hover:bg-indigo-100 transition-all cursor-pointer overflow-hidden group shadow-inner"
            >
              {fotoPreview ? (
                <img src={fotoPreview} alt="Preview" className="w-full h-full object-cover" />
              ) : (
                <>
                  <Camera size={32} />
                  <span className="text-[8px] font-black uppercase mt-2 italic">Nueva Foto</span>
                </>
              )}
            </div>
            <input type="file" hidden ref={fileInputRef} onChange={handleFotoChange} accept="image/*" />
          </div>

          <div className="space-y-6">
            <div className="space-y-2">
              <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-6 italic">Nombre Completo</label>
              <input 
                type="text" 
                className="w-full p-6 bg-slate-50 rounded-2xl border-2 border-transparent focus:border-indigo-500 font-black text-xl text-slate-800 outline-none transition-all shadow-inner uppercase" 
                value={adminData.nombre}
                onChange={(e) => setAdminData({...adminData, nombre: e.target.value.toUpperCase()})}
              />
            </div>

            <div className="grid grid-cols-2 gap-6">
              <div className="space-y-2">
                <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-6 italic">Cumpleaños</label>
                <input type="date" className="w-full p-6 bg-slate-50 rounded-2xl border-2 border-transparent focus:border-indigo-500 font-bold text-slate-800 outline-none shadow-inner" value={adminData.nacimiento} />
              </div>
              <div className="space-y-2">
                <label className="text-[10px] font-black text-slate-400 uppercase tracking-widest ml-6 italic">WhatsApp</label>
                <input type="tel" className="w-full p-6 bg-slate-50 rounded-2xl border-2 border-transparent focus:border-indigo-500 font-bold text-slate-800 outline-none shadow-inner" value={adminData.telefono} />
              </div>
            </div>

            <div 
              onClick={() => setAdminData({...adminData, whatsapp: !adminData.whatsapp})}
              className={`p-6 rounded-[2.5rem] border-4 flex items-center justify-between cursor-pointer transition-all ${
                adminData.whatsapp ? 'bg-emerald-50 border-emerald-200 shadow-md' : 'bg-slate-50 border-slate-200 opacity-60'
              }`}
            >
              <div className="flex items-center gap-4">
                <div className={`p-4 rounded-2xl ${adminData.whatsapp ? 'bg-emerald-500 text-white shadow-lg' : 'bg-slate-200 text-slate-400'}`}>
                  <Smartphone size={24} />
                </div>
                <div>
                  <p className="text-sm font-black uppercase text-slate-900 leading-none italic">Sincronizar WhatsApp</p>
                  <p className="text-[9px] font-bold text-slate-400 uppercase mt-2 tracking-widest">Para recibir alertas de incidencias graves</p>
                </div>
              </div>
              {adminData.whatsapp && <ShieldCheck size={28} className="text-emerald-500" />}
            </div>
          </div>

          <div className="flex gap-4 pt-4">
            <button onClick={() => setEditando(false)} className="flex-1 py-6 font-black text-[10px] uppercase text-slate-400 tracking-widest hover:text-rose-500 transition-colors italic">Descartar</button>
            <button 
              onClick={guardarCambios} 
              className="flex-[2] py-6 bg-indigo-600 text-white rounded-3xl font-black text-[11px] uppercase tracking-[0.2em] shadow-2xl hover:bg-emerald-600 active:scale-95 transition-all flex items-center justify-center gap-3 border-b-8 border-indigo-700"
            >
              <Save size={20} /> Guardar Credencial Maestra
            </button>
          </div>
        </div>
      )}

      {/* FOOTER DE PRIVACIDAD LEGAL */}
      <div className="bg-[#0A2440] p-10 rounded-[4rem] text-white flex items-start gap-6 shadow-2xl relative overflow-hidden border-b-8 border-amber-500">
        <div className="absolute top-0 right-0 w-32 h-32 bg-amber-500/5 rounded-full -mr-16 -mt-16 blur-2xl" />
        <div className="p-4 bg-amber-400 rounded-3xl text-slate-900 shadow-xl shrink-0">
          <ShieldCheck size={32} />
        </div>
        <div className="text-left">
          <p className="text-sm font-black uppercase tracking-widest italic leading-none">Compromiso de Privacidad</p>
          <p className="text-[10px] font-bold leading-relaxed opacity-60 italic uppercase tracking-widest mt-4">
            Como Administrador General de IgleKids, usted es responsable de la protección de datos de los menores. Este acceso total es auditado para garantizar la seguridad de Casa de Fe.
          </p>
        </div>
      </div>

    </div>
  );
};

export default PerfilAdmin;